export const JOB_PROFILE_SET = 'JOB_PROFILE_SET';
export const JOB_PROFILE_IS_LOADING = 'JOB_PROFILE_IS_LOADING';
export const JOB_PROFILE_ERROR = 'JOB_PROFILE_ERROR';
export const JOB_PROFILE_RESET = 'JOB_PROFILE_RESET';
export const JOB_PROFILE_DELETE = 'JOB_PROFILE_DELETE';
export const JOB_PROFILE_TAG_SET = 'JOB_PROFILE_TAG_SET';
